import { render } from "./MenuContentItemValueCheckbox.vue?vue&type=template&id=4560587c"
import script from "./MenuContentItemValueCheckbox.vue?vue&type=script&lang=js"
export * from "./MenuContentItemValueCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__